export interface ISetMenuItem {
  identifier: string;
  name: any;
  name_en: string;
  name_cn: string;
  name_kr: string;
  name_base: string;
  price: number;
  price_tax_excluded: string;
  allYouCanEat: boolean;
  quantity: number;
}
export class SetMenuItemDTO implements ISetMenuItem {
  identifier: string;
  name: any;
  name_en: string;
  name_cn: string;
  name_kr: string;
  name_base: string;
  price: number;
  price_tax_excluded: string;
  allYouCanEat: boolean;
  quantity: number;
}

export default class SetMenuItem extends SetMenuItemDTO {
  constructor(dto?: SetMenuItemDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      name: "",
      name_en: "",
      name_cn: "",
      name_kr: "",
      name_base: "",
      price: "",
      price_tax_excluded: "",
      allYouCanEat: "",
      quantity: 0,
    });
  }
}
